import React, { useState } from 'react';

import { Button } from '../Button/Button';
import { DriverBreakModal } from './DriverBreakModal';
import { timeDiffIntervalForHumans } from '../../utils/utils';

export const OrderListDriverBreakItem = ({ element, routeOrders, onRemoveDriverBreak }) => {
  const [isDriverBreakModalOpen, setIsDriverBreakModalOpen] = useState(false);

  const handelDriverBreakModalOpen = () => setIsDriverBreakModalOpen(true);
  const handleDriverBreakModalClose = () => setIsDriverBreakModalOpen(false);

  const timeInterval = timeDiffIntervalForHumans(element.durationInMin);

  return (
    <>
      <div
        className="order_map__item col-12 bg-primary bg-opacity-10 text-white order-map__item--added"
      >
        <div className="row mb--5px">
          <div className="col-md-6">
            <p className="tx-07 lp mb-0 lh-1-3rem opa-05">{__('routes.driver_break')}</p>

            <p className="tx-08 text-bold-700 mb-1 lh-1-3rem">{timeInterval}</p>
          </div>

          <div className="col-md-6 d-flex flex-column justify-content-end">
            <div className="d-flex">
              <Button
                onClick={handelDriverBreakModalOpen}
                className="btn-xs btn-outline-warning mr-5px mb-5px order-map__button hidden align-self-start"
                icon="bx bx-edit"
              />

              <Button
                onClick={() => onRemoveDriverBreak(element)}
                className="btn-xs btn-outline-danger mr-5px mb-5px order-map__button hidden align-self-start"
                icon="bx bx-x"
              />
            </div>
          </div>
        </div>
      </div>

      <DriverBreakModal
        routeOrders={routeOrders}
        isOpen={isDriverBreakModalOpen}
        onModalClose={handleDriverBreakModalClose}
        element={element}
      />
    </>
  );
};
